import { render, staticRenderFns } from "./succ.vue?vue&type=template&id=29dc381e&scoped=true"
import script from "./succ.vue?vue&type=script&lang=js"
export * from "./succ.vue?vue&type=script&lang=js"
import style0 from "./succ.vue?vue&type=style&index=0&id=29dc381e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dc381e",
  null
  
)

export default component.exports